<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                    <toolBar :loading.sync="mainLoading"
                             :menuId="menu_id"
                             :searchData="searchData"
                             @search="search"
                             @excel="excel">
                    </toolBar>
                    <tableGrid ref="tableGrid"
                               :sumObject="sumObject"
                               :showSummary="showSummary"
                               adaptiveHeight="123"
                               :headList="headList"
                               :dataList="dataList"
                               :pageInfo="pageInfo"
                               @tableOpt="tableOpt"
                               @toPage="toPage"
                               :loading="loading">
                    </tableGrid>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import toolBar from '@/components/page/purchase/purchaseanal/toolBar'
    import tableGrid from '@/components/tools/table'

    export default {
        name: "purchaseanal",
        props: ['menuData'],
        components: {tableGrid, toolBar},
        data() {
            return {
                showSummary:true,
                sumObject: {},
                mainLoading: false,
                menu_id: this.menuData.menuId,
                searchData: {
                    formData:{}
                },

                width: "350px",
                dialogLoading: false,
                formData: {},
                tableH: 100,
                dataList: [],
                loading: false,
                headList: [
                    {column_name: "_px", column_comment: "序号", column_width: "70"},
                    {column_name: "typeName", column_comment: "物资分类", column_width: "100"},
                    {column_name: "proName", column_comment: "物资名称", column_width: "150"},
                    {column_name: "proCode", column_comment: "物资编码", column_width: "100"},
                    {column_name: "units", column_comment: "物资计量单位", column_width: "100"},
                    {column_name: "specification", column_comment: "规格型号", column_width: "100"},
                    {column_name: "origin", column_comment: "产地", column_width: "100"},
                    {column_name: "color", column_comment: "颜色", column_width: "100"},
                    {column_name: "sumNum", column_comment: "采购数量", column_width: "150"},
                    {column_name: "avgPrice", column_comment: "平均单价", column_width: "150",type:'custom',
                        render: (h, data) => {
                            return h('div',this.$pub.getPrecisionData(data.avgPrice,this.precisionPrice));
                        }
                    },
                    {column_name: "sumTotal", column_comment: "采购合计", column_width: "150"}
                ],
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                }
            }
        },
        mounted() {
            this.getListData();
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/purchasestatistics/listAnalysis",
                    param: {
                        ...this.searchData.formData,
                        limit: this.pageInfo.pagesize,
                        page: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == "0") {
                    this.dataList = data.data.jsonObject.data;
                    this.sumObject = data.data.sumObject;
                    this.pageInfo.total = data.data.jsonObject.count;
                }
                this.loading = false;
            },

            toPage() {
                this.getListData();
            },
            search(data) {
                this.searchData.formData = data;
                this.pageInfo.page = 1;
                this.getListData();
            },
            excel(data) {
                this.searchData.formData = data;

                let param = {
                    url: "/purchasestatistics/excelAnalysis",
                    param: {
                        ...this.searchData.formData
                    }
                }

                this.$pub.openPostWindow(param);
            },
            tableOpt() {
            },
        }
    }
</script>

<style scoped lang="scss">

    ::v-deep .el-tabs__header{
        margin:0px;
    }
    ::v-deep .el-tabs--border-card>.el-tabs__content{
        padding: 10px;
    }

   .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }

        .Xdriver {
            position: relative;
            margin: 0 0;
            height: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }

        .Ydriver {
            position: relative;
            margin: 0 10px;
            width: 1px;
            background-color: #d4d4d4;
            text-align: center;
            font-size: 16px;
            color: rgba(101, 101, 101, 1);
        }
    }
</style>
